module.exports = __webpack_public_path__ + "static/media/lucky-wheel-img-3.7f8cfa26.png";